import React from "react";
import Konn3ctHeader from "../Header & Footer/Konn3ctHeader";
import Kpricing from "./PriceP1";
import Footer from "../Header & Footer/kfooter";

const PricingPage = () => {

  return (
    <div className="relative z-10 min-h-screen w-full bg-cover bg-center text-gray-900 font-sans overflow-hidden pt-[64px] sm:pt-[80px] md:pt-[100px]">
      <div
        className="absolute top-0 left-0 w-full h-[61vh] -z-10"
        style={{
          backgroundImage: `
            repeating-linear-gradient(to right, rgba(128,128,128,0.08) 0, rgba(128,128,128,0.08) 1px, transparent 1px, transparent 100px),
            repeating-linear-gradient(to bottom, rgba(128,128,128,0.08) 0, rgba(128,128,128,0.08) 1px, transparent 1px, transparent 100px)
          `,
        }}
      />

      <Konn3ctHeader />

      {/* <section className="relative text-center mt-11 px-4 sm:px-6 w-full z-20"> */}
        {/* <p className="text-sm font-semibold text-[#1A4699] mb-3">
          {country.name} pricing
        </p> */}

        {/* <h1 className="text-4xl md:text-5xl font-bold leading-tight text-black">
          Fair pricing <br /> that grows with you
        </h1>

        <p className="mt-4 text-base max-w-2xl mx-auto text-black">
          Choose the Konn3ct plan that fits the way you meet, collaborate,
          teach, host events, and grow.
        </p> */}
      {/* </section> */}

      <Kpricing />

      <div className="relative z-20 mt-10 space-y-16">
        <Footer />
      </div>
    </div>
  );
};

export default PricingPage;
